import { TableColumnGroup, TableColumnVisibilityControllerV2 } from "../../../shared/scripts/table-column-visibility";
import { FilterTab, ITableFilter, IFilterTable } from "../filter/filter.objects";
import { JsonItem } from "../web-form/web-form.objects";
import { plainToClass } from "class-transformer";
import { EditTableExport } from "./table-export";
import _ from "lodash";

export class EditTable implements IFilterTable {
    //From Config
    tableId: string; // unique ID for the table (no #)
    tableVarName: string; // at the page level the dot notation for table reference
    itemDisplayName: string;
    propertyIdName: string; // property name of data element Id (dot notation e.g., Id or NestedItem.Id)
    columns: any[]; // Columns for table
    tableColumnGroups: TableColumnGroup[];
    filterTabs: FilterTab[];
    isEditable: boolean; // can items in the table be edited
    isMultiselect: boolean; // can you select multiple items to edit
    editController: IEditController;  // can be undefined if not editing
    sortOrder: EditTableSortColumn[]; // default sorting of table
    tableExport: EditTableExport;

    // TargetIds
    loadedContentId: string;
    loadingContainerId: string;
    tableContainerId: string; 

    // Table
    editTable: any; // DataTable API
    tableController: TableColumnVisibilityControllerV2;
    useSelected: boolean = true; 

    // Items
    tableItems: EditTableItem[];
    visibleTableItems: any[];
    currentTargetItem: any;
    selectedTableItems: any[];

    // Pick Lists
    pickLists: JsonItem[] = [];
    allPickLists: JsonItem[] = [];

    constructor(config: EditTableConfig, tableExport: EditTableExport = undefined) {
        this.tableId = config.tableId;
        this.tableVarName = config.tableVarName;
        this.itemDisplayName = config.itemDisplayName;
        this.propertyIdName = config.propertyIdName;
        this.columns = config.columns;
        this.tableColumnGroups = config.tableColumnGroups;
        this.filterTabs = config.filterTabs;
        this.isEditable = config.isEditable;
        this.isMultiselect = config.isMultiselect;
        this.editController = config.editController;
        this.sortOrder = config.sortOrder;

        this.tableExport = tableExport;

        this.loadedContentId = `${this.tableId}-loaded-content`;
        this.loadingContainerId = `${this.tableId}-loading-container`;
        this.tableContainerId = `${this.tableId}-target-container`;

        this.useSelected = true;
    }

    // HTML Generation (Table, Filters)

    generateHtml(): string {

        let html = `
            <div id="${this.tableId}-container" class="edit-table-content">
                <div id="${this.tableId}-loading-container" class="loading-table-container">
                    <div class="text-center loading-table-text">
                        Loading...
                    </div>
                </div>
                <div id="${this.tableId}-loaded-content" class="edit-table-loaded-content d-none">
                    <div id="${this.tableId}-target-container" class="edit-table-content">
                        <p>Table Goes Here</p>
                    </div>
                </div>
            </div>
        `;

        return html;
    }

    private createHtmlTemplate(): void {
        let content = `
            <div id="${this.tableId}-filter-tab-container" class="d-flex justify-content-between">
                <ul class="nav nav-tabs justify-content-start border-bottom-0 ${this.filterTabs.length <= 1 ? "d-none" : ""}" id="${this.tableId}-filter-tabs" role="tablist">
                    
                </ul>
                <div class="d-flex align-items-center ${this.filterTabs.length <= 1 ? "mb-1 ml-auto w-100" : ""}">
                    <div class="font-italic pr-3 font-size14" id="${this.tableId}-table-count-found">${this.itemDisplayName} Found: 0</div>
                    <div class="${this.filterTabs.length <= 1 ? "ml-auto" : ""}">
                        <button class="btn btn-sm btn-outline-secondary font-size12 ${this.filterTabs.length == 0 ? "d-none" : ""}" onclick="page.${this.tableVarName}.resetFilters()">Reset Filters</button>
                    </div>
                </div>
            </div>

            <div class="tab-content edit-table-filter-tab-container ${this.filterTabs.length == 0 ? "d-none" : ""}" id="${this.tableId}-filter-container">
                
            </div>

            ${this.filterTabs.length == 0 ? "<hr />" : ""}

            <div class="${this.filterTabs.length > 0 ? "mt-4" : ""}">
                <div class="connect-datatable border-bottom edit-table-container" id="${this.tableId}-table-container">
                    
                </div>
            </div>
            <div id="${this.tableId}-detail-menu-container">

            </div>
        `

        $(`#${this.tableContainerId}`).empty().html(content);

        this.generateFilterTabContent();
    }

    private generateFilterTabContent(): void {
        // Create new Tab Content
        let tabContent = "";
        let filtersContent = "";
        for (let i = 0; i < this.filterTabs.length; i++) {
            let currentFilterTab: FilterTab = this.filterTabs[i];
            if (i == 0) {
                tabContent += `<li class="nav-item"><a class="nav-link active" id="${currentFilterTab.tabId}-tab" data-toggle="tab" href="#${currentFilterTab.tabId}" role="tab" aria-controls="${currentFilterTab.tabId}" aria-selected="true">${currentFilterTab.displayName}</a></li>`
                filtersContent += `<div class="tab-pane fade show active" id="${currentFilterTab.tabId}" role="tabpanel" aria-labelledby="${currentFilterTab.tabId}-tab"><div class='row'>`
            }
            else {
                tabContent += `<li class="nav-item"><a class="nav-link" id="${currentFilterTab.tabId}-tab" data-toggle="tab" href="#${currentFilterTab.tabId}" role="tab" aria-controls="${currentFilterTab.tabId}" aria-selected="false">${currentFilterTab.displayName}</a></li>`
                filtersContent += `<div class="tab-pane fade" id="${currentFilterTab.tabId}" role="tabpanel" aria-labelledby="${currentFilterTab.tabId}-tab"><div class='row'>`
            }

            for (let j = 0; j < currentFilterTab.filters.length; j++) {
                let filter: ITableFilter = currentFilterTab.filters[j];
                filtersContent += filter.generateFilterHtml();
            }

            filtersContent += `</div></div>`
        }

        // Update Tabs
        $(`#${this.tableId}-filter-tabs`).empty().html(tabContent);
        $(`#${this.tableId}-filter-container`).empty().html(filtersContent);

        // Generate Dropdown
        for (let i = 0; i < this.filterTabs.length; i++) {
            let currentFilterTab: FilterTab = this.filterTabs[i];
            for (let j = 0; j < currentFilterTab.filters.length; j++) {
                let currentFilter: ITableFilter = currentFilterTab.filters[j];
                currentFilter.initialize(this.tableItems, this)
            }
        }

        this.filterTabs.forEach(tab => {
            if (tab.columnViewName) {
                $(`#${tab.tabId}-tab`).on('click', () => {
                    $(`#column-filter-dropdown-${this.tableId}-table-column-visibility`).val([`${tab.columnViewName}`])
                    $(`#column-filter-dropdown-${this.tableId}-table-column-visibility`).trigger("change");
                })
            }
        });
    }

    // Initialization (Get Items, Table, Filters)

    initialize(items: any[], pickLists: JsonItem[]): void {
        this.loadingDisplay(true);

        this.tableItems = plainToClass(EditTableItem, <EditTableItem[]>items);
        this.pickLists = pickLists;

        this.allPickLists = [...this.pickLists];

        if (this.tableExport) {
            this.tableExport.initialize(this.pickLists);
        }

        this.createHtmlTemplate();
        this.initializeFilterAndTable();

        this.loadingDisplay(false);
        this.resizeTable();
    }

    private initializeFilterAndTable() {
        // Select Table
        $(`#${this.tableId}-table-container`).empty().html(
            `<table id="${this.tableId}" class="table table-striped selectable-rows w-100" style="width:100%"></table>`
        )

        // Clear Detail Menu Container
        $(`#${this.tableId}-detail-menu-container`).empty();

        // Create Table
        this.initializeTable();

        // in case some table cells contain popovers
        this.initializePopovers();
    }

    private initializeTable(): void {
        let columns = _.cloneDeep(this.columns);
        let currentSort = _.cloneDeep(this.sortOrder);

        let tableColumns: any[] = [];
        if (this.isMultiselect && this.isEditable) {
            tableColumns = [
                { title: `<div class="form-check"><input id="${this.tableId}-select-all" class="form-check-input" type="checkbox"></div>`, orderable: false, width: "15px", className: "text-center item-select-option", data: { _: "IsSelected", display: "SelectorDisplay" } }
            ];
            currentSort.forEach(order => order.colIndex += 1);
        }
        let firstColumn = columns.shift();
        if (firstColumn) {
            tableColumns.push(firstColumn);
            if (this.isEditable) {
                tableColumns.push(
                    { data: this.propertyIdName, title: "", width: "26px", orderable: false, className: "text-center detail-btn-container", render: (data) => this.renderDetailButton(data) }
                );
                currentSort.forEach(order => {
                    if (order.colIndex >= tableColumns.length) {
                        order.colIndex += 1;
                    }
                })
            }
        }
        tableColumns.push(...columns);

        let sort = currentSort.map(order => [order.colIndex, order.sortType]);

        let fixedColCount = 1;
        if (this.isMultiselect && this.isEditable) fixedColCount = 3;
        else if (this.isEditable) fixedColCount = 2; 

        // Export Rules
        let csvBtn: any = {
            extend: 'csv',
            filename: `${this.itemDisplayName}_Download`,
            text: '<i class="fas fa-file-download"></i>',
            titleAttr: 'CSV',
            charset: 'utf-8'
        }

        if (this.tableExport) {
            csvBtn = {
                extend: 'csv',
                filename: this.tableExport.filename,
                text: '<i class="fas fa-file-download"></i>',
                titleAttr: 'CSV',
                charset: 'utf-8',
                customize: () => {
                    return this.tableExport.createCsvData(this.visibleTableItems)
                }
            }
        }

        this.editTable = $(`#${this.tableId}`).DataTable({
            "dom": `<"${this.tableId}-top-controls"<"${this.tableId}-column-select"><"${this.tableId}-search-bar"f><"${this.tableId}-count-found"B>>rtip`,
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            //responsive: false,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: fixedColCount
            },
            language:
            {
                search: "Search",
            },
            columns: tableColumns,
            buttons: [
                csvBtn
            ],
            data: this.tableItems,
            order: sort,
            initComplete: (settings, json) => {

            },
        });

        $(`.${this.tableId}-top-controls`).addClass('row mx-0 align-items-center');

        $(`.${this.tableId}-column-select`).addClass('col-12 col-md-3 px-0 mb-2');
        $(`.${this.tableId}-column-select`).empty().html(`<div id="${this.tableId}-column-select"></div>`);
        $(`.${this.tableId}-search-bar`).addClass('col-12 col-md-3');
        $(`.${this.tableId}-count-found`).addClass('col-12 col-md-6 d-flex justify-content-end vertical-align-middle mt-3 px-0');
        $(`.${this.tableId}-count-found`).prepend(`<div id="${this.tableId}-selected-items-block" class="edit-table-multiselect-block align-self-center pr-3"></div>`);

        this.tableController = new TableColumnVisibilityControllerV2(`#${this.tableId}`, `#${this.tableId}-column-select`, this.tableColumnGroups, `${this.tableId}-table-column-visibility`);

        if (this.isMultiselect) {
            $(`#${this.tableId} tbody`).off().on('click', 'td', (event) => {
                let td = $(event.currentTarget);
                if (td.hasClass("item-select-option")) {
                    this.updateSelector(td.find(".form-check-input").first());

                    // also hide any dropdown menus
                    $(`#${this.tableId}-detail-menu-container`).find(".connect-dropdown-menu").removeClass("show");
                    return;
                }
            });
        }   

        this.initializeTableCheckbox();

        this.updateCount(this.tableItems.length);
        this.visibleTableItems = this.tableItems;
    }

    // Multi-Select 
    initializeTableCheckbox(): void {
        let selectAllCheckboxId = `#${this.tableId}-select-all`;
        $(selectAllCheckboxId).off().on('click', () => {
            $(selectAllCheckboxId).prop("indeterminate", false);

            if ($(selectAllCheckboxId).prop("checked")) {
                let visibleItems: EditTableItem[] = this.editTable.rows().data().toArray();
                visibleItems.forEach(item => item.updateSelect(true));
                this.updateTable(visibleItems);
                this.setSelectedItemsLabel(visibleItems.length);
                this.setSelectedItems(this.getSelectedItems());
                $(`#${this.tableId}`).find("tr").addClass("row-selected");
            }
            else {
                this.clearSelectedItems();
            }
        })
    }

    clearSelectedItems(): void {
        let selectAllCheckboxId = `#${this.tableId}-select-all`;
        $(selectAllCheckboxId).prop("checked", false);
        $(selectAllCheckboxId).prop("indeterminate", false);
        let visibleItems: EditTableItem[] = this.editTable.rows().data().toArray();
        visibleItems.forEach(item => item.updateSelect(false));
        this.updateTable(visibleItems);
        this.setSelectedItems([])
        this.setSelectedItemsLabel(0);
    }

    updateSelector(checkbox: JQuery<HTMLElement>): void {
        let tr = $(checkbox).closest('tr');
        let row = this.editTable.row(tr);
        let currentData: EditTableItem = row.data();
        let isChecked = !currentData.IsSelected;
        currentData.updateSelect(isChecked);
        row.data(currentData);

        if (isChecked) {
            $(tr).addClass("row-selected");
        }
        else {
            $(tr).removeClass("row-selected");
        }

        this.updateSelectorAll();
    }

    updateSelectorAll(): void {
        let visibleItems: EditTableItem[] = this.editTable.rows().data().toArray();
        let selectedItems = this.getSelectedItems();
        let selectAllCheckboxId = `#${this.tableId}-select-all`;
        if (visibleItems.length == selectedItems.length) {
            $(selectAllCheckboxId).prop("checked", true);
            $(selectAllCheckboxId).prop("indeterminate", false);
        }
        else if (selectedItems.length == 0) {
            $(selectAllCheckboxId).prop("checked", false);
            $(selectAllCheckboxId).prop("indeterminate", false);
        }
        else {
            $(selectAllCheckboxId).prop("checked", false);
            $(selectAllCheckboxId).prop("indeterminate", true);
        }

        this.setSelectedItems(selectedItems);
        this.setSelectedItemsLabel(selectedItems.length);
    }

    getSelectedItems(): EditTableItem[] {
        let visibleItems: EditTableItem[] = this.editTable.rows().data().toArray();
        let selectedItems = visibleItems.filter(item => item.IsSelected);
        return selectedItems;
    }

    setSelectedItems(selectedItems: any[]): void {
        this.selectedTableItems = selectedItems;
    }

    setSelectedItemsLabel(itemCount: number): void {
        if (itemCount == 0) {
            $(`#${this.tableId}-selected-items-block`).empty();
        }
        else {
            let text = ""
            if (itemCount == 1) {
                text = "1 Item Selected";
            }
            else {
                text = `${itemCount} Items Selected`
            }

            let content = `
                <div class="btn-group" role="group">
                    <div class="selected-items-text font-size13">
                        <i class="fa-solid fa-xmark fa-lg clear-selected-btn pr-2" onclick='page.${this.tableVarName}.clearSelectedItems()'></i> ${text}
                    </div>

                    <div class="btn-group connect-btn-dropdown" role="group">
                        <button id="editItemOptions" type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Edit
                        </button>
                        <div class="dropdown-menu dropdown-menu-right connect-dropdown-menu" aria-labelledby="editItemOptions">
                            ${this.getMenuContent()}
                        </div>
                    </div>
                </div>

            `
            $(`#${this.tableId}-selected-items-block`).empty().html(content);
        }
    }

    // Filtering

    triggerFilter(): void {
        let filteredItems: any[] = _.cloneDeep(this.tableItems);

        this.filterTabs.forEach(tab => {
            tab.filters.forEach(filter => {
                filteredItems = filter.filterItems(filteredItems);
            })
        });

        this.updateTable(filteredItems);
    }

    resetFilters(): void {
        this.filterTabs.forEach(tab => {
            tab.filters.forEach(filter => {
                filter.resetFilter();
            })
        });

        this.updateTable(this.tableItems);
    }

    getSelectedFilterTabId(): string {
        let selectedTab = $(`#${this.tableId}-filter-tabs`).find(".active").first();
        return selectedTab.prop("id");
    }

    // Edit Menu

    renderDetailButton(data: any): string {

        let content = `
            <div class="btn-group dropright">
                <button type="button" class="btn dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onclick="page.${this.tableVarName}.updateMenuPosition(event)">
                    <div class="item-detail-button" data-id="${data}"><div><i class="fa-solid fa-ellipsis"></i></div></div>
                </button>
                <div class="dropdown-menu connect-dropdown-menu">
                    
                </div>
            </div>
        `
        return content;
    }

    updateMenuPosition(e: Event) {
        // set current selected row
        let targetElement = <JQuery<HTMLElement>>$(e.currentTarget);
        this.setTargetedRow(targetElement);

        // empty any existing menus (menus are moved to this div to avoid overflow issues with table)
        $(`#${this.tableId}-detail-menu-container`).empty();

        let dropdownMenu = targetElement.siblings('.connect-dropdown-menu');
        let dropdownContainer = targetElement.parent();

        let useSelected = this.checkIsSelected(targetElement);
        this.useSelected = useSelected;

        // Check is the dropdown menu has been moved to the new #detail-menu-container 
        if (dropdownMenu.length <= 0) {
            // if the menu has already been moved, remove existing dropdwon relationship, and create a new one with new menu options
            targetElement.dropdown('dispose');
            dropdownContainer.append(`
                <div class="dropdown-menu connect-dropdown-menu">
                    ${this.getMenuContent(useSelected)}
                </div>
            `)
            targetElement.dropdown();
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find('.connect-dropdown-menu');
                $(`#${this.tableId}-detail-menu-container`).append(<JQuery<HTMLElement>>$(updatedDropdownMenu))
            });
        }
        else {
            // if the menu has not already been moved (first click), just add the correct menu options.
            dropdownMenu.html(`
                ${this.getMenuContent(useSelected)}
            `)
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find(".connect-dropdown-menu");
                $(`#${this.tableId}-detail-menu-container`).append(<JQuery<HTMLElement>>$(updatedDropdownMenu));
            });
        }
    }

    private setTargetedRow(target: JQuery<HTMLElement>): void {
        let tr = $(target).closest('tr');
        let row = this.editTable.row(tr);
        this.currentTargetItem = row.data();
    }

    private getMenuContent(useSelected: boolean = true): string {
        let menuOptions = "";

        let isMultipleSelected = this.getSelectedItems().length > 1;
        if (isMultipleSelected && useSelected) {
            menuOptions += `<div class="font-weight-bold font-size14 px-4 py-1">${this.getSelectedItems().length} Selected</div>`
        }

        menuOptions += this.editController.getEditMenu();
        return menuOptions;
    }

    // Helper Functions

    private loadingDisplay(isLoading: boolean): void {
        if (isLoading) {
            $(`#${this.loadedContentId}`).addClass("d-none");
            $(`#${this.loadingContainerId}`).removeClass("d-none");
        }
        else {
            $(`#${this.loadedContentId}`).removeClass("d-none");
            $(`#${this.loadingContainerId}`).addClass("d-none");
        }
    }

    private updateCount(numItems: number): void {
        let content = "";
        if (numItems == 1) {
            content = `${this.itemDisplayName} Found: 1`
        }
        else {
            content = `${this.itemDisplayName} Found: ${numItems.toString()}`
        }

        $(`#${this.tableId}-table-count-found`).text(content);
    }

    private checkIsSelected(target: JQuery<HTMLElement>): boolean {
        let tr = $(target).closest('tr');
        let row = this.editTable.row(tr);
        let currentData: EditTableItem = row.data();

        return currentData.IsSelected;
    }

    private initializePopovers(): void {
        // In case some table items are popovers (User Directory)
        let foundPopovers = $('[data-toggle="popover"]');
        if (foundPopovers.length > 0) {
            $('[data-toggle="popover"]').popover();
        }
    }

    resizeTable(): void {
        if (this.editTable) {
            this.editTable.columns.adjust().draw();
        }
    }

    updateTable(items: any[]) {
        // Removes any shown menus
        $("#detail-menu-container").empty();

        this.editTable.clear();
        this.editTable.rows.add(items).draw();
        this.updateCount(items.length);
        this.resizeTable();
        this.visibleTableItems = items;

        this.initializePopovers();
    }

    getCurrentTableSort(): any[] {
        let currentOrder: any[] = this.editTable.order(); // [[0, "asc"], [1, "desc"], ...]
        return currentOrder;
    }

    setCurrentTableSort(sortOrder: any[]): void {
        if (sortOrder.length > 0) {
            for (let i = 0; i < sortOrder.length; i++) {
                let colIndex = sortOrder[i][0];
                let colDir = sortOrder[i][1];
                this.editTable.order([colIndex, colDir]);
            }
            this.editTable.draw();
        }
    }

    scrollToTableItem(targetId: number = -1) {
        // Used to indicate new item (will be the largest ID)
        if (targetId == -1) {
            let idArr: number[] = this.tableItems.map(item => item.Id);
            let maxVal = Math.max(...idArr);
            targetId = maxVal;
        }

        let foundIndex = 0;

        // Find Row
        this.editTable.rows((index: number, data: EditTableItem, node) => {
            if (data?.Id == targetId) {
                foundIndex = index;
            }
            return false;
        });
        let foundRow = this.editTable.row(foundIndex);
        let foundRowHtml = foundRow.node();

        // Scroll to Row
        let foundRowPosition = $(foundRowHtml).position().top;
        let tableBody = $(`#${this.tableId}-table-container`).find(".dataTables_scrollBody");
        tableBody.animate({ scrollTop: foundRowPosition }, 400);
    }
}

export class EditTableItem {
    Id: number;
    IsSelected: boolean = false;
    SelectorDisplay: string = `<div class="form-check"><input class="form-check-input" type="checkbox"></div>`;

    updateSelect(isSelected: boolean): void {
        this.IsSelected = isSelected;
        if (this.IsSelected) {
            this.SelectorDisplay = `<div class="form-check"><input class="form-check-input" type="checkbox" checked></div>`;
        }
        else {
            this.SelectorDisplay = `<div class="form-check"><input class="form-check-input" type="checkbox"></div>`;
        }
    }
}

export class EditTableConfig {
    tableId: string; // unique ID for the table (no #)
    tableVarName: string; // Name of EditTable property from page (dot notation e.g. editTable or table.editTable)
    propertyIdName: string; // property name of data element Id (dot notation e.g., Id or NestedItem.Id)
    itemDisplayName: string; // Name of item;
    columns: any[]; // Columns for table
    tableColumnGroups: TableColumnGroup[];
    filterTabs?: FilterTab[];
    isEditable: boolean; // can items in this table be edited
    isMultiselect: boolean; // can you select multiple items to edit in this table
    editController: IEditController; // controller to handle getting menu content
    sortOrder: EditTableSortColumn[];
}

export interface IEditController {
    getEditMenu(): string; // Gets options for edit table
    saveItems(items: any[], isAdd: boolean): Promise<void>; //method for saving
}

export class EditTableSortColumn {
    colIndex: number; // column index (as specified in config)
    sortType: string; // 'asc' or 'desc'

    constructor(colIndex: number, sortType: string) {
        this.colIndex = colIndex;
        this.sortType = sortType;
    }
}